"use client";

import { Shield, FileCheck, Award } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function QualityCompliance() {
  const {
    ref: section1Ref,
    isVisible: section1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card1Ref,
    isVisible: card1Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card2Ref,
    isVisible: card2Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: card3Ref,
    isVisible: card3Visible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const features = [{
    icon: Shield,
    title: "Rigorous Quality Control",
    description: "Every shipment undergoes multi-stage inspection from origin to delivery, ensuring compliance with international standards and your exact specifications."
  }, {
    icon: FileCheck,
    title: "Complete Documentation",
    description: "Full traceability with COO certificates, lab reports, packing lists, and customs paperwork—prepared accurately for seamless clearance."
  }, {
    icon: Award,
    title: "Certified Compliance",
    description: "Our processes align with ISO, HACCP, and regional regulatory frameworks, giving you confidence in safety and quality assurance."
  }];
  return <section id="quality-compliance" className="relative py-20 lg:py-28 overflow-hidden" style={{
    backgroundColor: "#F6F3EC"
  }}>
      <div className="container mx-auto px-6 lg:px-12">
        <div ref={section1Ref} className={`text-center mb-16 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${section1Visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <h2 className="font-display text-4xl lg:text-5xl font-bold text-foreground mb-4">
            Quality & Compliance
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Clean-room precision in every detail. We ensure transparency, traceability, and adherence to global standards at every step.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const cardRef = i === 0 ? card1Ref : i === 1 ? card2Ref : card3Ref;
          const cardVisible = i === 0 ? card1Visible : i === 1 ? card2Visible : card3Visible;
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={cardRef} className={`group transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`} style={{
            transitionDelay: `${i * 100}ms`
          }}>
                <Card className="h-full bg-white shadow-soft hover:shadow-medium hover:-translate-y-1.5 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] border-b-4 border-transparent hover:border-accent overflow-visible">
                  <CardContent className="flex flex-col items-center text-center gap-4 p-8">
                    <div className="transition-transform duration-[var(--duration-medium)] ease-[var(--ease-out-back)] group-hover:scale-110" style={{
                  transform: cardVisible ? "scale(1)" : "scale(0.8)",
                  transition: "transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1)"
                }}>
                      <Icon className="w-16 h-16 text-accent stroke-[1.5]" />
                    </div>
                    <h3 className="font-display text-2xl font-semibold text-foreground">
                      {feature.title}
                    </h3>
                    <p className="text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}